import React from 'react';

import BaseClass from '@/pages/BaseClass';

import Index from '@/pages/user/study/index';
import Order from '@/pages/user/order';
import Profile from '@/pages/user/profile';
import Result from '@/pages/user/result';

import {Route, Switch,} from 'react-router-dom';

import {CommonValue, httpPost, pcUrl,} from '@/utils/tools';

export default class App extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {
            'navIndex': 0,
            'userInfo': {},
        };
    }

    componentDidMount() {
        this.navIndexInit(this.props.location.pathname);
        this.props.history.listen(event => {
            this.navIndexInit(event.pathname);
        });
        /*
        window.addEventListener('hashchange',(event)=>{
            this.navIndexInit();
        });
        */

        this.getUserInfo();
    }

    navIndexInit(hash) {
        /*
        let url = window.location.href;
        let hash = url.split('#').pop();
        */

        let navIndex = -1;
        if ('/user' == hash || '/user/index' == hash) {
            navIndex = 0;
        } else if ('/user/result' == hash) {
            navIndex = 1;
        } else if ('/user/order' == hash) {
            navIndex = 2;
        } else if ('/user/profile' == hash) {
            navIndex = 3;
        }

        this.setState({navIndex});
    }

    getUserInfo() {
        let url = pcUrl('/personal');

        httpPost(url, {}, 'get')
            .then(data => {
                CommonValue.set('user_info', data);
                this.setState({
                    'userInfo': data,
                });
            });
    }

    render() {
        return (
            <>
                <div className="height-20"></div>
                <div className="body">

                    <div className="index-left">
                        <div className="user-info">
                            <dl>
                                <dd>
                                    <img src={this.state.userInfo.avatar || require('@/assets/images/avatar.png')}/>
                                </dd>
                                <dt>{this.state.userInfo.name}</dt>
                                <dd className="desc" title={this.state.userInfo.schoolName}>
                                    {this.state.userInfo.schoolName}
                                </dd>
                                <dd className="desc">
                                    {this.state.userInfo.classes}
                                </dd>
                            </dl>
                        </div>
                        <div className="user-nav">
                            <ul>
                                <li><a href="javascript:;" onClick={() => window.open('/user/index', '_blank')}
                                       className={0 == this.state.navIndex ? 'now' : ''}> 我的学习中心 </a></li>
                                <li><a href="javascript:;" onClick={() => window.open('/user/result', '_blank')}
                                       className={1 == this.state.navIndex ? 'now' : ''}> 我的学习成果 </a></li>
                                <li><a href="javascript:;" onClick={() => window.open('/user/order', '_blank')}
                                       className={2 == this.state.navIndex ? 'now' : ''}> 课题记录 </a></li>
                                <li><a href="javascript:;" onClick={() => window.open('/user/profile', '_blank')}
                                       className={3 == this.state.navIndex ? 'now' : ''}> 个人设置 </a></li>
                            </ul>
                        </div>
                    </div>
                    <div className="index-right">
                        <Switch>
                            <Route exact path="/" component={Index}/>
                            <Route exact path="/user" component={Index}/>
                            <Route path="/user/index" component={Index}/>
                            <Route path="/user/result" component={Result}/>
                            <Route path="/user/order" component={Order}/>
                            <Route path="/user/profile">
                                <Profile userInfo={this.state.userInfo} updateUserInfo={() => this.getUserInfo()}/>
                            </Route>
                            {/*
						<Route path="/user/report/:id" render={routeProps=>(
							<Report {...routeProps} userInfo={this.state.userInfo} />
						)}/>
						*/}
                        </Switch>
                    </div>
                    <div className="clear"></div>
                </div>
            </>
        );
    }
}

